export const font = {
  url: 'https://dc-webtoolkit.azureedge.net/font/fontStyles.css',
  family: 'Bosch Sans',
  size: {
    small: '1rem',
    medium: '1.5rem',
    large: '2rem',
  },
};

// inject font into the document
export function injectFont() {
  // check if the font is already injected
  if (
    document.querySelector(`link[href="${font.url}"]`) ||
    document.querySelector(`link[href*="nextgen-web-ui-toolkit.css"]`)
  ) {
    return;
  }

  const link = document.createElement('link');
  link.rel = 'stylesheet';
  link.href = font.url;
  document.head.appendChild(link);
}
